module.exports = __webpack_public_path__ + "static/media/image19.0812f27f.png";